import { Pagination } from "react-admin";

export const required = (message = 'Parametro richiesto') =>
value => value ? undefined : message;

export const CustomPagination = props => <Pagination rowsPerPageOptions={[6, 12, 24, 50]} {...props} />;

export function addMonths(date, months) {
    var d = date.getDate();
    date.setMonth(date.getMonth() + +months);
    if (date.getDate() !== d) {
      date.setDate(0);
    }
    return date;
}

export const choices = [
  { _id: 0, state: 'Non attivo' },
  { _id: 1, state: 'Attivo' },
  { _id: 2, state: 'Sospeso' },
];